(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-contrast-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ss-reveal:not([data-ss-observed])');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    sections.forEach((section) => {
      section.dataset.ssObserved = 'true';
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-dual-state"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ss-reveal-states:not([data-ss-observed])');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    sections.forEach((section) => {
      section.dataset.ssObserved = 'true';
      observer.observe(section);
    });
  })();

  (() => {
    const bindCarouselControls = (root = document) => {
      root.querySelectorAll('button[is="next-button"][aria-controls], button[is="prev-button"][aria-controls]').forEach((button) => {
        if (button.dataset.ssCarouselBound === 'true') return;

        const carousel = document.getElementById(button.getAttribute('aria-controls'));
        if (!carousel || carousel.tagName !== 'SCROLL-CAROUSEL') return;

        button.dataset.ssCarouselBound = 'true';
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          const direction = button.getAttribute('is') === 'next-button' ? 1 : -1;
          const firstCard = carousel.querySelector('product-card, .product-card');
          const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : carousel.clientWidth * 0.82;
          const gap = Number.parseFloat(getComputedStyle(carousel.querySelector('.product-list') || carousel).columnGap) || 24;

          carousel.scrollBy({ left: direction * (cardWidth + gap) * 3, behavior: 'smooth' });
        });
      });
    };

    bindCarouselControls();
    document.addEventListener('DOMContentLoaded', () => bindCarouselControls(), { once: true });
    document.addEventListener('shopify:section:load', (event) => bindCarouselControls(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ss-product-faq--reveal:not([data-ss-observed])');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    sections.forEach((section) => {
      section.dataset.ssObserved = 'true';
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ss-product-story--reveal:not([data-ss-observed])');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    sections.forEach((section) => {
      section.dataset.ssObserved = 'true';
      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
